export const WidgetCardSkeletonOverlay = ({ isDataLoading }: { isDataLoading: boolean }) => {
  return (
    <>
      <div
        className={`absolute inset-0 z-10 overflow-hidden transition-opacity duration-500 ease-out ${
          isDataLoading ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
      >
        <div
          className={`absolute inset-0 bg-gradient-to-r ${isDataLoading ? 'animate-pulse' : ''} from-gray-200 via-gray-100 to-gray-200 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700`}
        />
      </div>
    </>
  );
};
